import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/GridTable/StyleConstant';
import { caseInsensitiveComparator } from '../../../../Display/NDC/utility/tableHeads';

export const labelerTableHead = [
  {
    headerName: 'Labeler Code',
    field: 'labelerCode',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Labeler Name',
    field: 'labelerName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    comparator: caseInsensitiveComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const manufacturersTableHead = [
  {
    headerName: 'Manufacturers ID',
    field: 'labelerCode',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturers Name',
    field: 'labelerName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const NDCTableHead = [
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'ndcName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellClass: 'frr-ellipsis-text',
    cellRenderer: 'DrugNameCell',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const ExcludedNDCsDetailTableHead = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    filter: false,
    showCheckboxIcon: true,
    suppressMenu: false,
    maxWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellClass: 'ag-cell-action',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'IconButtonCell',
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_150,
    maxWidth: Styles.Width_230,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'ndcName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_250,
    cellRenderer: 'DrugNameCell',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Excluded Start Qtr',
    field: 'startQtr',
    editable: false,
    sortable: true,
    required: true,
    suppressMenu: false,
    minWidth: Styles.Width_230,
    // maxWidth: Styles.Width_200 + Styles.Width_20,
    cellRenderer: 'TextBoxRender',
    custClass: 'tbill-rate-editable-input',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorParams: {
      maxLength: Styles.Length_8,
      custWidth: '135px',
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Excluded End Qtr',
    field: 'endQtr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200 + Styles.Width_5 - Styles.Width_20,
    maxWidth: Styles.Width_200 + Styles.Width_20,
    cellRenderer: 'TextBoxRender',
    custClass: 'tbill-rate-editable-input',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorParams: {
      maxLength: Styles.Length_8,
      custWidth: '135px',
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Valid',
    field: 'excludedNdcStatusCd',
    cellRenderer: 'CheckboxCell',
    showCheckboxIcon: true,
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    minWidth: Styles.Width_100,
    cellClass: 'ag-cell-checkbox',
    cellStyle: {
      borderRightColor: Styles.BorderColor,
      textAlign: 'left',
    },
  },
];
